var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgOvLine2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 96,
    viewBox: "0 0 452 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M443.852 47.6754C447.343 37.3102 440.755 33.7991 438.154 45.6938C427.789 42.1958 424.278 48.7901 436.173 51.3913C432.681 61.763 439.275 65.2746 441.876 53.3799C452.241 56.8713 455.753 50.2836 443.858 47.6823L443.852 47.6754Z",
    fill: "#FEC106"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-311.736 20.5269C-134.032 -71.7274 251.34 193.028 432.975 53.2601",
    stroke: "white",
    strokeWidth: 1.05133,
    strokeDasharray: "2.1 2.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgOvLine2);
export default __webpack_public_path__ + "static/media/prog-ov-line-2.9652596325be088b6c593c0113dc61a2.svg";
export { ForwardRef as ReactComponent };